const AWSStatusCode = {
	SUCCESS: 'SUCCESS',
	FAIL: 'FAIL'
}

export { AWSStatusCode }
